import React from 'react';

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  return (
    totalPages > 1 && (
      <div className="training-pagination-widget">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          aria-label={I18n.t('training_overview_page.details.back')}
        >
          <i className="fas fa-chevron-left" aria-hidden="true"></i>
        </button>

        <span>
          {currentPage} {I18n.t('training_overview_page.details.of')}{' '}
          {totalPages}
        </span>

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          aria-label={I18n.t('training_overview_page.details.next')}
        >
          <i className="fas fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    )
  );
};

export default Pagination;
